export const stripeState = {
    method: 'GET',
    paths: ['/redirect/stripe'],
    fields: {
        locationId: {
            type: 'mongoId',
            required: true,
        },
        integrationId: {
            type: 'mongoId',
            required: true,
        },
        url: {
            type: 'url',
            required: true,
        },
        env: {
            type: 'keyString',
            required: true,
        },
    },
    // the request will have query-string param state which this schema is for
};
//# sourceMappingURL=oauth_stripe_state.js.map